import { render, staticRenderFns } from "./Xzzy.vue?vue&type=template&id=66edd5d2&scoped=true"
import script from "./Xzzy.vue?vue&type=script&lang=js"
export * from "./Xzzy.vue?vue&type=script&lang=js"
import style0 from "./Xzzy.vue?vue&type=style&index=0&id=66edd5d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66edd5d2",
  null
  
)

export default component.exports